import styled from '@emotion/styled';
import { colors, fontSizes, gutterSizes } from '@gumtree/ui-library/src/base/theme';
import carAd from './logo-2x.png';

export const BoxSecondary = styled.div`
    position: relative;
    margin: 0 0 ${gutterSizes.base};
    padding: 0;
    border: 1px solid ${colors.bark20};
    border-radius: 3px;
    display: block;
`;

export const BoxSection = styled.div`
    border-bottom: 1px solid ${colors.branch10};
    padding: 16px;
    background-color: ${colors.white};
`;

export const BoxTitle = styled.h3`
    background-color: ${colors.blade10};
    margin-bottom: 0;
    border-bottom: 1px solid ${colors.branch10};
    padding: 15px 18px;
    font-weight: 400;
    border-radius: 3px 3px 0 0;
    font-size: ${fontSizes.xlarge};
`;

export const VhcFooter = styled(BoxSection)`
    color: ${colors.blade};
    background-color: ${colors.blade10};

    p:last-child {
        margin-bottom: 12px;
    }

    .button--secondary {
        margin-top: ${gutterSizes.medium};
    }
`;

export const HpiCheckLogo = styled.span`
    background-image: url(${carAd});
    background-repeat: no-repeat;
    background-size: 81px 21px;
    width: 81px;
    height: 21px;
    margin-top: 6px;
    float: right;
`;

export const VhcFooterTitle = styled(BoxTitle)`
    padding: 0;
    margin-bottom: 12px;
    border: 0;
    font-size: ${fontSizes.header};
`;

export const AttributeItem = styled.li`
    border-bottom: 1px solid ${colors.bark10};
    padding-top: 6px;
    padding-bottom: 6px;
    list-style: none;

    &:first-of-type {
        padding-top: 0;
    }

    &:last-child {
        border-bottom: 0;
        padding-bottom: 0;
    }
`;

export const AdvisoryNotice = styled.div`
    margin-top: 8px;
    margin-left: 1em;
`;

export const AdvisoryResult = styled.span`
    color: ${colors.orange};
    float: right;
`;

export const PassedResult = styled.span`
    vertical-align: center;
    float: right;
    color: ${colors.green};
    display: flex;
    align-content: flex-start;
`;

export const AttributeName = styled.span`
    font-weight: bold;
`;
